module.exports = {"430723001":"澧西街道","430723002":"澧阳街道","430723003":"澧浦街道","430723004":"澧澹街道","430723102":"小渡口镇","430723103":"梦溪镇","430723104":"复兴镇","430723105":"盐井镇","430723107":"大堰垱镇","430723108":"王家厂镇","430723109":"金罗镇","430723110":"码头铺镇","430723112":"甘溪滩镇","430723113":"火连坡镇","430723114":"澧南镇","430723115":"如东镇","430723116":"涔南镇","430723117":"官垸镇","430723118":"城头山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430723.json
// module id = 1712
// module chunks = 0